import speedtest_component from '#BASE/components/speedTest/speedTest.component';
import downloadcenter_component from 'BASE/components/downLoad/DownLoadCenterAndAFK';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import loginEntryDownload from 'YD/components/Download/loginEntryDownload.component';

export default {
    mixins: [speedtest_component, loginEntryDownload, downloadcenter_component],
    components: { 
        qrcode: VueQrcode,
    },
    data: function () {
        return {
            MaxShow: 6,        //設定最多顯示
            QrcodeOptions: {
                width: 112,
                margin: 1,
            },
            checkSettingComplete: true,
        };
    },
    computed: {
        year(){
            return new Date().getFullYear();
        },
        AndroidURL() {
            if (this.androidUrl == "" )
                this.androidUrl = this.AndroidOrPcFile("apk");

            return this.androidUrl;
        },
        iOSURL() {
            if (this.iosUrl == "" )
                this.iosUrl = `${this.originURL}/IOSDownload`;

            return this.iosUrl;
        }
    },
};